/* KOJO custom layer — home behaviour: <kj-hero-pin> (rotating «Lleva» pin), <kj-spotlight> (add a 2-product set), hero video toggle, video fade-in.
   Depends on window.KJ (assets/kojo-core.js, loaded earlier with defer). Safe to load several times. */
(function () {
  'use strict';
  if (window.__kjHome) return;
  window.__kjHome = true;

  var doc = document;
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function money(cents) {
    if (window.KJ && typeof window.KJ.formatMoney === 'function') return window.KJ.formatMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }

  /* ---------- fade videos in once they actually play (image underneath stays the poster/LCP) ---------- */
  doc.addEventListener('playing', function (e) {
    var v = e.target;
    if (v && v.hasAttribute && v.hasAttribute('data-kj-fade')) v.classList.add('is-playing');
  }, true);

  /* ---------- hero: pause / play toggle (WCAG 2.2.2) ---------- */
  function heroVideos(btn) {
    var root = btn.closest('.kj-hero');
    return root ? Array.prototype.slice.call(root.querySelectorAll('video')) : [];
  }
  function initToggles(ctx) {
    Array.prototype.forEach.call((ctx || doc).querySelectorAll('[data-kj-video-toggle]'), function (btn) {
      if (btn._kj) return;
      btn._kj = true;
      if (reduced()) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var pause = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', pause ? 'true' : 'false');
        btn.setAttribute('aria-label', pause ? 'Reproducir vídeo' : 'Pausar vídeo');
        heroVideos(btn).forEach(function (v) {
          v._kjUserPaused = pause;
          if (!v._kjGuard) {
            v._kjGuard = true;
            // the core autoplay observer calls play() when the video re-enters the viewport: respect the user's choice
            v.addEventListener('play', function () { if (v._kjUserPaused) v.pause(); });
          }
          if (pause) { v.pause(); }
          else {
            if (v.dataset.src && !v.getAttribute('src') && v.offsetParent !== null) v.src = v.dataset.src;
            var p = v.play && v.offsetParent !== null ? v.play() : null;
            if (p && p.catch) p.catch(function () {});
          }
        });
      });
    });
  }

  /* ---------- <kj-hero-pin>: «Lleva» pin rotating through the products of the photo ----------
     The active dot's CSS fill animation (--kj-pin-dur) is the timer: its animationend moves to the next product,
     so pausing (hover, focus, off-screen, hidden tab, hero video paused) is just animation-play-state.
     A click on a dot = the user takes control: auto-rotation stops for good. Reduced motion: no auto-rotation. */
  if (!customElements.get('kj-hero-pin')) {
    customElements.define('kj-hero-pin', class extends HTMLElement {
      connectedCallback() {
        if (!this._bound) this.bind();
        if (!this._bound || this._live) return;
        var self = this;
        this._live = true;
        this.hold('view', true); // until the observer reports it on screen
        this._onVis = function () { self.hold('tab', doc.hidden); };
        doc.addEventListener('visibilitychange', this._onVis);
        this._onVis();
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { self.hold('view', !en.isIntersecting); });
          });
          this._io.observe(this);
        } else {
          this.hold('view', false);
        }
        // the hero's video pause button also pauses the rotation (read its state after its own handler ran)
        var hero = this.closest('.kj-hero');
        this._toggle = hero ? hero.querySelector('[data-kj-video-toggle]') : null;
        if (this._toggle) {
          this._onToggle = function () {
            setTimeout(function () { if (self._toggle) self.hold('video', self._toggle.getAttribute('aria-pressed') === 'true'); }, 0);
          };
          this._toggle.addEventListener('click', this._onToggle);
        }
        // the pill takes the width of the current product (animated on change); re-measure when fonts land / on resize
        this._onResize = function () {
          clearTimeout(self._rt);
          self._rt = setTimeout(function () { self.measure(); }, 150);
        };
        window.addEventListener('resize', this._onResize);
        this.measure();
        if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { if (self._live) self.measure(); });
        // restart the current fill: this script may run after the first one already ended (slow network)
        this.restartFill();
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this._onVis) doc.removeEventListener('visibilitychange', this._onVis);
        if (this._toggle && this._onToggle) this._toggle.removeEventListener('click', this._onToggle);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        clearTimeout(this._rt);
        this._io = this._onVis = this._onToggle = this._toggle = this._onResize = null;
        this._live = false;
      }

      // element-level listeners, attached once
      bind() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-kj-pin-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-kj-pin-dot]'));
        if (this.slides.length < 2 || this.dots.length !== this.slides.length) return;
        this._bound = true;
        var self = this;
        this.track = this.querySelector('[data-kj-pin-track]');
        this.index = 0;
        this.holds = {};
        this.addEventListener('animationend', function (e) {
          if (e.animationName !== 'kj-pin-progress' || self._stopped || reduced()) return;
          if (e.target.closest('[data-kj-pin-dot]') !== self.dots[self.index]) return;
          self.go(self.index + 1);
        });
        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            // the hero renders one copy per layout (mobile / desktop): keep both on the user's choice
            var hero = self.closest('.kj-hero');
            var pins = hero ? hero.querySelectorAll('kj-hero-pin') : [self];
            Array.prototype.forEach.call(pins, function (pin) {
              if (pin._bound && pin.slides.length === self.slides.length) { pin.stop(); pin.go(i); }
            });
          });
        });
        this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.hold('hover', true); });
        this.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.hold('hover', false); });
        // keyboard focus only: a mouse click also focuses the link (e.g. open in a new tab) and hover already pauses
        this.addEventListener('focusin', function (e) {
          var kb = true;
          try { kb = e.target.matches(':focus-visible'); } catch (err) {}
          if (kb) self.hold('focus', true);
        });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.hold('focus', false); });
      }

      hold(key, on) {
        if (on) this.holds[key] = true; else delete this.holds[key];
        this.classList.toggle('is-paused', Object.keys(this.holds).length > 0);
      }

      stop() {
        if (this._stopped) return;
        this._stopped = true;
        this.classList.add('is-stopped');
        if (this.track) this.track.setAttribute('aria-live', 'polite');
      }

      // each slide keeps its natural width (capped to the room available, then the title ellipsizes) so text never
      // reflows while the pill grows/shrinks; the pill (overflow hidden) animates to the width of the current slide.
      // measure() runs on connect, when fonts land and on resize; go() only animates to the cached width.
      measure() {
        var pill = this.track;
        if (!pill || !this.offsetParent) { this.widths = null; return; } // hidden copy: measured when it shows up
        var parent = this.parentElement;
        var pcs = getComputedStyle(parent);
        var room = parent.clientWidth - parseFloat(pcs.paddingLeft) - parseFloat(pcs.paddingRight);
        // desktop copy shares the hero row with the text column, which cannot shrink below its own min-content
        var content = parent.classList.contains('kj-hero__inner') ? parent.querySelector('.kj-hero__content') : null;
        if (content) {
          var w0 = content.style.width;
          var f0 = content.style.flex;
          content.style.width = 'min-content';
          content.style.flex = 'none';
          var cw = content.getBoundingClientRect().width;
          content.style.width = w0;
          content.style.flex = f0;
          room -= cw + (parseFloat(pcs.columnGap) || 0);
        }
        var mw = getComputedStyle(this).maxWidth;
        if (/px$/.test(mw)) room = Math.min(room, parseFloat(mw));
        var cs = getComputedStyle(pill);
        this._border = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
        this._bb = cs.boxSizing === 'border-box';
        var cap = Math.max(120, Math.floor(room - this._border));
        this.widths = this.slides.map(function (s) {
          s.style.minWidth = '0';
          s.style.width = 'max-content';
          var w = Math.ceil(s.getBoundingClientRect().width);
          s.style.width = '';
          s.style.minWidth = Math.min(w, cap) + 'px';
          return Math.min(w, cap);
        });
        this.classList.add('is-fit');
        this.fit(false);
      }

      fit(animate) {
        var pill = this.track;
        if (!pill || !this.widths) return;
        if (!animate) pill.classList.add('is-instant');
        pill.style.width = (this.widths[this.index] + (this._bb ? this._border : 0)) + 'px';
        if (!animate) {
          void pill.offsetWidth;
          pill.classList.remove('is-instant');
        }
      }

      restartFill() {
        var dot = this.dots[this.index];
        if (!dot) return;
        dot.classList.remove('is-active');
        void dot.offsetWidth;
        dot.classList.add('is-active');
      }

      go(i) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        if (i === this.index) return;
        var prev = this.slides[this.index];
        var next = this.slides[i];
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        prev.setAttribute('aria-hidden', 'true');
        prev.setAttribute('tabindex', '-1');
        prev.setAttribute('inert', '');
        clearTimeout(prev._kjLeave);
        prev._kjLeave = setTimeout(function () { prev.classList.remove('is-leaving'); }, 650);
        clearTimeout(next._kjLeave);
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
        next.removeAttribute('tabindex');
        next.removeAttribute('inert');
        this.dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        this.index = i;
        if (this.widths && this.offsetParent) this.fit(true);
      }
    });
  }

  /* ---------- <kj-spotlight>: adds every product of the set in one request ---------- */
  if (!customElements.get('kj-spotlight')) {
    customElements.define('kj-spotlight', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-kj-set-item]'));
        this.btn = this.querySelector('[data-kj-set-add]');
        this.err = this.querySelector('[data-kj-set-error]');
        this.addEventListener('change', this.onChange.bind(this));
        if (this.btn) this.btn.addEventListener('click', this.onAdd.bind(this));
      }

      selection(item) {
        var mode = item.dataset.mode;
        var el;
        if (mode === 'single') {
          el = item.querySelector('[data-kj-set-fixed]');
          return el ? { id: el.value, price: Number(el.dataset.price || 0) } : null;
        }
        if (mode === 'chips') {
          el = item.querySelector('input[type="radio"]:checked');
          return el ? { id: el.value, price: Number(el.dataset.price || 0) } : null;
        }
        if (mode === 'select') {
          el = item.querySelector('[data-kj-set-select]');
          if (el && el.value) {
            var opt = el.options[el.selectedIndex];
            return { id: el.value, price: Number(opt.dataset.price || 0) };
          }
        }
        return null;
      }

      missing() {
        var self = this;
        return this.items.filter(function (it) { return it.dataset.required === 'true' && !self.selection(it); });
      }

      updateTotal() {
        var self = this;
        var total = 0;
        this.items.forEach(function (it) {
          var sel = self.selection(it);
          total += sel ? sel.price : Number(it.dataset.minPrice || 0);
        });
        Array.prototype.forEach.call(this.querySelectorAll('[data-kj-set-total]'), function (el) {
          el.textContent = money(total);
        });
      }

      onChange(e) {
        var item = e.target.closest('[data-kj-set-item]');
        if (item) {
          item.classList.remove('is-error');
          var chosen = item.querySelector('[data-kj-set-chosen]');
          if (chosen && e.target.dataset && e.target.dataset.label) chosen.textContent = ' · ' + e.target.dataset.label;
        }
        this.updateTotal();
        if (this.err && !this.err.hidden && !this.missing().length) this.err.hidden = true;
      }

      showError(msg) {
        if (!this.err) return;
        this.err.textContent = msg;
        this.err.hidden = false;
      }

      onAdd() {
        var self = this;
        var missing = this.missing();
        if (missing.length) {
          this.showError(this.dataset.sizeError || 'Elige tu talla');
          missing.forEach(function (it) {
            it.classList.remove('is-error');
            void it.offsetWidth; // restart the shake animation
            it.classList.add('is-error');
          });
          var first = missing[0].querySelector('input:not([disabled]), select');
          if (first) {
            try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
            var r = missing[0].getBoundingClientRect();
            if (r.top < 80 || r.bottom > window.innerHeight) missing[0].scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
          }
          return;
        }
        var lines = this.items.map(function (it) {
          var sel = self.selection(it);
          return sel ? { id: sel.id, quantity: 1 } : null;
        }).filter(Boolean);
        if (!lines.length) return;

        if (!window.KJ || !window.KJ.cart) {
          // fallback without the core runtime: plain AJAX add, then go to the cart page
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { self.showError('No hemos podido añadir el set. Inténtalo de nuevo.'); });
          return;
        }
        window.KJ.setLoading(this.btn, true);
        window.KJ.cart.add(lines, { source: this.dataset.source || 'home-spotlight' })
          .then(function () { if (self.err) self.err.hidden = true; })
          .catch(function (err) {
            self.showError((err && err.message) || window.KJ.t('cart_error', 'No hemos podido actualizar el carrito. Inténtalo de nuevo.'));
          })
          .then(function () { window.KJ.setLoading(self.btn, false); });
      }
    });
  }

  /* ---------- lazy video posters (data-poster): set ~600px before the video reaches the viewport.
     kojo-core.js does the same for video[data-kj-autoplay]; this is a harmless fallback for the spotlight. ---------- */
  var posterIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var v = en.target;
      if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
      posterIO.unobserve(v);
    });
  }, { rootMargin: '600px 0px' }) : null;
  function initPosters(ctx) {
    var root = ctx && ctx.querySelectorAll ? ctx : doc;
    Array.prototype.forEach.call(root.querySelectorAll('.kj-spot video[data-poster]'), function (v) {
      if (v._kjPoster) return;
      v._kjPoster = true;
      if (posterIO) posterIO.observe(v); else v.setAttribute('poster', v.dataset.poster);
    });
  }

  /* ---------- boot + theme editor ---------- */
  function init(ctx) { initToggles(ctx); initPosters(ctx); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.kj-hero--overlap')) doc.body.classList.remove('kj-has-overlap');
  });
})();
